import { useQuery } from "@apollo/client";
import { LoadingSpinner } from "pepsico-ds";
import { useMemo } from "react";
import { listSweepstakesActive } from "../../../graphql/queries/listSweepstakesActive";
import OutcomeRulesSetup from "../ActivitySetup/OutcomeRulesSetup";
import { isOutcomeRuleConfigured } from "../campaignUtils";
import {
  isRetailerConditionRule,
  isStoreConditionRule,
  isSurveyConditionRule,
} from "../rulesAndOutcomes/outcomes/conditionTypeUtils";
import ViewComponentsRenderer from "./ViewComponentsRenderer";

const SweepstakesOutcomeComponent = (props) => {
  const selectedSweepstakes = props.data?.sweepstakes_ids ?? props.data?.target_id;
  const outcome = props.definition;
  const pathname = window.location.pathname;
  const isSummary = pathname.includes("summary");
  const updateOutcome = props?.updateOutcome;

  const { data, loading } = useQuery(listSweepstakesActive, {
    variables: {
      filter: {
        page: 0,
        size: 1000,
      },
    },
  });

  const sweepstakes = useMemo(() => {
    const sweepstakesData = data?.listSweepstakesLatest?.items?.filter(
      (sweepstakes) =>
        selectedSweepstakes?.includes(sweepstakes.id) ||
        selectedSweepstakes === sweepstakes.id
    );

    return sweepstakesData?.map((item) => item.title) || [];
  }, [data, selectedSweepstakes]);

  return (
    <div>
      <div className="display-flex align-center" style={{ gap: "1rem" }}>
        {loading ? (
          <LoadingSpinner size={{ height: "16px", width: "16px" }} />
        ) : (
          <>
            <h5>Sweepstakes: {sweepstakes?.join(", ")}</h5>
          </>
        )}
      </div>
      {isSummary ? (
        outcome?.outcomeRules?.length > 0 &&
        outcome?.outcomeRules
          ?.filter(isOutcomeRuleConfigured)
          .filter(
            (rule) =>
              !isRetailerConditionRule(rule) &&
              !isStoreConditionRule(rule) &&
              !isSurveyConditionRule(rule)
          )
          .map((rule, i) => (
            <ViewComponentsRenderer
              data={rule.ruleData}
              inputSchema={rule.ruleDefinition?.inputSchema}
              customComponentName={rule.ruleDefinition?.slug}
              uiSchema={rule.ruleDefinition?.uiSchema || {}}
              key={rule.ruleDefinition?.slug + i + JSON.stringify(rule.ruleData)}
              ruleDefinition={rule.ruleDefinition}
            />
          ))
      ) : (
        <OutcomeRulesSetup
          outcome={outcome}
          updateOutcome={(updatedOutcome) =>
            updateOutcome?.(updatedOutcome, props.index)
          }
        />
      )}
    </div>
  );
};

export default SweepstakesOutcomeComponent;
